import { ISBN_PATTERN_STRING } from '@content-registration/utils/isbn-checksum';
import { ISSN_PATTERN_STRING } from '@content-registration/utils/issn-checksum';
import { ORCID_PATTERN_STRING } from '@content-registration/utils/orcid-checksum';

export const doiDefinition = {
  type: 'string',
  pattern: '^10\\.\\d{4,9}/[-._;()/:a-zA-Z0-9]+$',
  i18n: 'doi',
};

export const issnDefinition = {
  type: 'string',
  pattern: ISSN_PATTERN_STRING,
  issnChecksum: true,
  i18n: 'form_input_issn',
};

export const orcidDefinition = {
  type: 'string',
  pattern: ORCID_PATTERN_STRING,
  orcidChecksum: true,
  i18n: 'person_ORCID',
};

export const isbnDefinition = {
  type: 'object',
  i18n: 'isbn',
  properties: {
    electronicIsbn: {
      type: 'string',
      pattern: ISBN_PATTERN_STRING,
      isbnChecksum: true,
      i18n: 'electronicIsbn',
    },
    printIsbn: {
      type: 'string',
      pattern: ISBN_PATTERN_STRING,
      isbnChecksum: true,
      i18n: 'printIsbn',
    },
  },
};

export const landingPageUrlDefinition = {
  type: 'string',
  i18n: 'landingPageUrl',
  format: 'url',
  notDoiUrl: true,
};

export const similarityCheckUrlDefinition = {
  type: 'string',
  i18n: 'similarityCheckUrl',
  format: 'url',
  notDoiUrl: true,
};

export const publisherDefinition = {
  type: 'string',
  i18n: 'publisher',
};

export const referencesDefinition = {
  type: 'string',
  i18n: 'references',
};

export const languageCodesDefinition = {
  type: 'string',
  i18n: 'crossref_language_codes',
  crossrefLanguage: true,
};

export const abstractDefinition = {
  type: 'object',
  properties: {
    abstract: {
      type: 'string',
    },
    language: {
      $ref: '#/definitions/crossref_language_codes',
      uniqueValue: true,
    },
  },
};

export const publicationDatesDefinition = {
  type: 'object',
  i18n: 'publicationDates',
  requireAny: ['online', 'print'],
  default: {},
  properties: {
    online: {
      type: 'string',
      format: 'date',
    },
    print: {
      type: 'string',
      format: 'date',
    },
  },
};

export const contributorDefinition = {
  type: 'object',
  required: ['familyName', 'role', 'sequence'],
  properties: {
    givenName: {
      i18n: 'person_givenName',
      type: 'string',
    },
    familyName: {
      i18n: 'person_familyName',
      type: 'string',
    },
    suffix: {
      i18n: 'person_suffix',
      type: 'string',
      maxLength: 10,
    },
    affiliation: {
      title: 'Affiliation',
      type: 'object',
      properties: {
        institution: {
          i18n: 'person_affiliation_institution',
          type: 'string',
        },
        ror: {
          i18n: 'person_affiliation_ror',
          type: 'string',
        },
      },
    },
    orcid: {
      ...orcidDefinition,
      uniqueValue: true,
    },
    role: {
      i18n: 'person_role',
      type: 'string',
      enum: [
        'first-author',
        'additional-author',
        'editor',
        'chair',
        'reviewer',
        'review-assistant',
        'stats-reviewer',
        'reviewer-external',
        'reader',
        'translator',
      ],
    },
    sequence: {
      type: 'string',
      enum: ['first', 'additional'],
    },
  },
};

export const contributorsDefinition = {
  type: 'array',
  minItems: 1,
  default: [{}],
  items: {
    $ref: '#/definitions/contributor',
  },
  i18n: 'contributors',
};

export const optionalContributorsDefinition = {
  type: 'array',
  default: [{}],
  items: {
    $ref: '#/definitions/contributor',
  },
  i18n: 'contributors',
};

export const abstractsDefinition = {
  type: 'array',
  default: [{}],
  items: abstractDefinition,
  i18n: 'abstracts',
};
